export default "/canonical_face_model.obj";